var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTasksEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard-tasks-empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard-tasks-empty",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1F1F1",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#A1A1A1",
    points: "5.68434189e-14 10.7143159 5.56317307 5.15114282 11.1263461 10.7143159 21.547274 -9.9475983e-14 26.9118053 5.15114282 10.9709786 21.4286318"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#D6D6D6",
    points: "11.1263461 10.7143159 5.66560981 16.1750522 10.9191894 21.4286318 16.2763473 16.0714738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTasksEmpty);
export default __webpack_public_path__ + "static/media/dashboard-tasks-empty.d3bdba77efa82d6c6dbf3303b6dee8d1.svg";
export { ForwardRef as ReactComponent };